import { SequenceCard } from "./SequenceCard";
import { SequenceTemplate } from "./types";

interface SavedSequencesListProps {
  sequences: Array<{ id: string; sequence_details: SequenceTemplate }>;
  onEdit: (sequence: SequenceTemplate) => void;
  onDelete: (id: string) => Promise<void>;
}

export const SavedSequencesList = ({ sequences, onEdit, onDelete }: SavedSequencesListProps) => {
  if (!sequences || sequences.length === 0) {
    return (
      <div className="text-center p-4 text-muted-foreground">
        No sequences found
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {sequences.map((sequence) => (
        <SequenceCard
          key={sequence.id}
          sequence={sequence.sequence_details}
          onEdit={() => onEdit(sequence.sequence_details)}
          onDelete={() => onDelete(sequence.id)}
        />
      ))}
    </div>
  );
};